
(function () {

  function showHelp() {
    $('.breadcrumb-nav').show();
    $('.app-title').show();
    $('.chat-presence').show();
    $('#page-wrap-element').addClass('page-wrap');
    $('.page-footer').show();
  }

  function showInAppFooter(content) {
    if (!content) { return; }

    var containerFooter = content.find('.container-footer');
    if (containerFooter.length) {
      var contactUs = $('.page-footer .contact-us-container');
      if (contactUs.length) {
        contactUs.detach().appendTo(containerFooter);
      }
    }
  }

  function showInAppHelp() {
    $('.help-pagetitle').addClass('pagetitle-inapp');
    $('.inapp-nav').show();

    var contentBody = $('#content-body');
    if (contentBody.length) {
      var content = contentBody;
      var contentTop = content.offset().top;
      var windowHeight = $(window).height();
      var scrollHeight = windowHeight - contentTop;

      content.height(scrollHeight);
      content.css('overflow-y', 'auto');

      showInAppFooter(content);
    }
  }

  function resizeContent() {
    if (gdhelp2.utils.inIframe()) {
      showInAppHelp();
    }
  }

  /*
   * Marks the page as being visually complete.  Its expected that this only gets called once.
   *
   * @public
   */
  function sendVisualComplete() {
    if (window && window._trfq && window.performance && window.performance.mark) {
      window.performance.mark('visual_complete');
      window._trfq.push(['cmdLogPagePerf']);
    }
  }

  function ready() {

    if (gdhelp2.utils.inIframe()) {
      showInAppHelp();
    } else {
      showHelp();
    }

    sendVisualComplete();
  }

  var gdhelp = {
    home: function () {
      window.location.href = requestContext.hostPath;
      return this;
    }
  };

  window.gdhelp = gdhelp;

  $(document).ready(ready);
  $(window).resize(resizeContent);

}());
